import React, { useEffect } from 'react';
import styles from './style.module.css';
import { BackPage, Forms, OrderBar } from 'components';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const FindPharmacyByPostcode = () => {
  const history = useHistory();

  const startedJourney = useSelector((state) => state.paymentJourney.started);

  useEffect(() => {
    if (!startedJourney) history.push('/pharmacy/dashboard');
  }, [history, startedJourney]);

  return (
    <>
      <OrderBar currentProgress={0} />
      <BackPage onBackClick={() => history.push('/pharmacy/dashboard/delivery-options')}>
        <h1 className={styles.header}>Find your nearest Pharmacy</h1>
        <Forms.FindPharmacyByPostcodeForm />
      </BackPage>
    </>
  );
};

export default FindPharmacyByPostcode;
